// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__1MQN3","logo":"App_logo__1ItuU"};